import { Text } from '@/components/text';

import type { ErrorMessageProps } from './message.types';

const ErrorMessage = ({ id, children }: ErrorMessageProps) => (
  <Text
    id={id}
    variant="body3"
    className="text-error"
  >
    {children}
  </Text>
);

export default ErrorMessage;
